import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { SettingDto } from 'shared/service-proxies/models/setting-dto.model';
import { SettingListDto } from 'shared/service-proxies/models/setting-list-dto.model';
import { SettingServiceProxy } from 'shared/service-proxies/services/setting.service';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  androidAppLink: boolean = false;
  iosAppLink: boolean = false;
  thumbStatusCheck: SettingListDto[];
  androidLink: any;
  iosLink: any;
  /**
   * Constructor
   */
  constructor(private settingService: SettingServiceProxy,
    private authService: AuthenticationService) {
  }
  ngOnInit(): void {
    if (this.authService.isAuthenticated())
      this.showField();
  }
  showField() {
    this.settingService.getAllSettings().subscribe(response => {
      if (response.isSuccess) {
        this.thumbStatusCheck = response.responseData;
        if (this.thumbStatusCheck.length > 0)
          this.androidLink = this.thumbStatusCheck[0].androidAppLink;
        this.iosLink = this.thumbStatusCheck[0].iosAppLink;
        if (this.androidLink != "") {
          this.androidAppLink = true;
        }
        else {
          this.androidAppLink = false;
        }
        if (this.iosLink != "") {
          this.iosAppLink = true;
        }
        else {
          this.iosAppLink = false;
        }
      }
    });
  }
}
